// discount js start
function readdiscountCodeData(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
$(document).ready(function(){
  $('.discount_poup_btn').click(function(){
    $('.enter_discount_code_main').addClass('enter_discount_code_main_open');
  });
  $('.enter_discount_code_inner span.close').click(function(){
    $('.enter_discount_code_main').removeClass('enter_discount_code_main_open');
  });
  $('.discount_shipping_address_hide span.close').click(function(){
    $('.discount_shipping_address_hide').removeClass('discount_shipping_address_open')
  });
  $('.discount_code_single').each(function() {
    var discountCode = $(this).attr('discountcode');
});
  
  $('.enter_discount_code_inner #discountCodeInput').on('change input', function(e) {
    if ($(this).val() !== '') {
        $('.alert').remove();
    }
});
  
  $('.enter_discount_code_inner #submitCode').click(function() {
    var discountVal = $('.enter_discount_code_inner #discountCodeInput').val();
    document.cookie = "discountCodeData="+discountVal+"; path=/";
    if (discountVal === '') {
        $('.enter_discount_code_inner #discountCodeInput').after('<span class="alert">Please enter a code</span>');
    } else {
        var matchFound = false;
        var discountName = '';

        $('.discount_code_single').each(function() {
            var discountCode = $(this).attr('discountcode');
            if (discountVal === discountCode) {
                matchFound = true;
                discountName = $(this).attr('discountname');
                $('.enter_discount_code_inner span.close').addClass('close_reload')
                setTimeout(function(){
                  // $('input[placeholder="Coupon Code"]').attr("aria-invalid", "false");
                   // $('input[placeholder="Coupon Code"]').trigger('click');
                  var inputElement = $('input[placeholder="Coupon Code"]');
                    
                     inputElement.trigger('focus');
                      // inputElement.trigger('blur');
                      // inputElement.trigger('change');
                      inputElement.trigger('click');
                  setTimeout(function(){
                    $('input[placeholder="Coupon Code"]').val(discountVal);
                  },300)
                  
                },500);
                
                return false; // Break out of the each loop once a match is found
            }
        });
 
        if (matchFound) {
            $('.enter_discount_code_inner #discountCodeInput').val('');
            $('.enter_discount_code_inner').addClass('increase_width');
            $('.free_gift_name').text("CONGRATULATIONS YOU'VE WON "+discountName); // Corrected variable name
            //if (discountName.includes("Polo")) {
            if (discountName == 'One Free Polo') {
                $('input[placeholder="Quarter Zip Size.."]').parent().addClass('hide_from_input');
                $('input[placeholder="Select Golf Polo 1 Size"]').parent().addClass('hide_from_input');
                $('input[placeholder="Select Gold Polo 2 Size"]').parent().addClass('hide_from_input');
                $('input[placeholder="Select Golf Polo 3 Size"]').parent().addClass('hide_from_input');

                $('input[placeholder="Select Golf Polo 1 Size"]').parent().parent().parent().find('label').addClass('hide_from_input');
                $('input[placeholder="Select Gold Polo 2 Size"]').parent().parent().parent().find('label').addClass('hide_from_input');
                $('input[placeholder="Select Golf Polo 3 Size"]').parent().parent().parent().find('label').addClass('hide_from_input');
            }
            else if (discountName.includes("Zip")) {
                $('input[placeholder="Select Golf Polo Size.."]').parent().addClass('hide_from_input');
                $('input[placeholder="Select Golf Polo 1 Size"]').parent().addClass('hide_from_input');
                $('input[placeholder="Select Gold Polo 2 Size"]').parent().addClass('hide_from_input');
                $('input[placeholder="Select Golf Polo 3 Size"]').parent().addClass('hide_from_input');

                $('input[placeholder="Select Golf Polo 1 Size"]').parent().parent().parent().find('label').addClass('hide_from_input');
                $('input[placeholder="Select Gold Polo 2 Size"]').parent().parent().parent().find('label').addClass('hide_from_input');
                $('input[placeholder="Select Golf Polo 3 Size"]').parent().parent().parent().find('label').addClass('hide_from_input');
            }
            else if (discountName == 'Three Free Polos') {
                $('input[placeholder="Select Golf Polo Size.."]').parent().addClass('hide_from_input');
                $('input[placeholder="Quarter Zip Size.."]').parent().addClass('hide_from_input');
                // $('input[placeholder="Select Golf Polo 1 Size"]').parent().addClass('hide_from_input');
                // $('input[placeholder="Select Gold Polo 2 Size"]').parent().addClass('hide_from_input');
                // $('input[placeholder="Select Golf Polo 3 Size"]').parent().addClass('hide_from_input');
            }
            else {
              
              $('input[placeholder="Select Golf Polo Size.."]').parent().addClass('hide_from_input');
                $('input[placeholder="Quarter Zip Size.."]').parent().addClass('hide_from_input');
                $('input[placeholder="Select Golf Polo 1 Size"]').parent().addClass('hide_from_input');
                $('input[placeholder="Select Gold Polo 2 Size"]').parent().addClass('hide_from_input');
                $('input[placeholder="Select Golf Polo 3 Size"]').parent().addClass('hide_from_input');

                $('input[placeholder="Select Golf Polo 1 Size"]').parent().parent().parent().find('label').addClass('hide_from_input');
                $('input[placeholder="Select Gold Polo 2 Size"]').parent().parent().parent().find('label').addClass('hide_from_input');
                $('input[placeholder="Select Golf Polo 3 Size"]').parent().parent().parent().find('label').addClass('hide_from_input');
                
            }
            $('.discount_shipping_address_hide').addClass('discount_shipping_address_open');
            $('.enter_discount_code_main').removeClass('enter_discount_code_main_open');
            $('.alert').remove();
        } else {
            $('.enter_discount_code_inner #discountCodeInput').after('<span class="alert">Please enter valid code</span>');
        }
    }
});

$(document).on('click', '.enter_discount_code_inner span.close_reload', function(){
   var emptycode = '';
   document.cookie = "discountCodeData="+emptycode+"; path=/";
   location.reload();
});  
$(document).on('click', 'form.needsclick button.needsclick', function(){
  // $('input[placeholder="Coupon Code"]').attr("aria-invalid", "false");
  // setTimeout(function(){
  //                 // $('input[placeholder="Coupon Code"]').attr("aria-invalid", "false");
  //                 $('input[placeholder="Coupon Code"]').triggerHandler('focus');
  //                 $('input[placeholder="Coupon Code"]').val("yes");
  //               },2000);
});

var checkInterval = setInterval(function() {
        // Check if the text exists on the page
        if ($('body').text().includes('Thank you for playing The Game with Breakfast Balls.')) {
            $('.free_gift_name').hide();
            var disCode = readdiscountCodeData('discountCodeData');
            $.ajax({
            url: 'https://rsvlts.store/api/discount-codes/update',  // PHP file to handle the update
            type: 'POST',       // HTTP method
            data: {
                code: disCode,    // The code you're looking for
                new_value: 1
            },
            success: function(response) {
            },
            error: function(xhr, status, error) {
            }
        });
         
            clearInterval(checkInterval); // Stop the interval after the text is found
        }
    }, 10);
});

// discount js end